import axios from 'axios'

const DriverService = {
  async get (params = {}) {
    return axios.get('lo/drivers', { params })
  },

  async post (params = {}) {
    return axios.post('lo/drivers', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`lo/drivers/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`lo/drivers/${data.id}`, { data })
  }
}

export default DriverService
